<template>
  <div class="mt-component-form print-container mb-4">
    <vs-row class="my-4 end-flex">
      <h5><i class="dot"></i>{{title}}</h5>
      <div class="ml-auto">
        <vs-button
          v-if="!isPrint"
          class=""
          color="secondary"
          type="border"
          @click="handleRemoveRow">선택삭제</vs-button>
        <vs-button
          v-if="!isPrint"
          class="ml-4"
          color="secondary"
          @click="handleAddRow">항목추가</vs-button>
      </div>
    </vs-row>

    <div class="w-full">
      <!--    head-->
      <div class="grid row-header border-left" style="font-weight: 700;" :style="!isPrint?
           'grid-template-columns: 36px 60px 213fr 120px 120px 400fr 54px 340px 213fr'
           : 'grid-template-columns: 60px 213fr 120px 120px 400fr 54px 340px 213fr'">

        <div v-if="!isPrint" class="row-header__item border-right">
          <vs-checkbox
            v-model="tableAllCheck"
            @change="changeAllCheck"
          ></vs-checkbox>
        </div>
        <div class="row-header__item border-right">No.</div>
        <div class="row-header__item border-right">물질명<br>(제품명)</div>
        <div class="row-header__item border-right">취급량<br>(L/월)</div>
        <div class="row-header__item border-right">사용기간<br>(시간/월)</div>
        <div class="row-header__item border-right">사용용도<br>(작업내용)</div>
        <div class="row-header__item border-right">MSDS<br>게시</div>
        <div class="row-header__item border-right">
          <div class="w-full h-full" style="display: grid; grid-template-rows: 1fr 1fr; align-items: center;">
            <div class="h-full border-bottom " style="display: grid; align-items: center;">관리 해당 여부</div>
            <div class="h-full grid" style="grid-template-columns: 40px 40px 40px 40px 180px">
              <span class="border-right" style="display: grid; align-items: center;">MSDS 교육</span>
              <span class="border-right" style="display: grid; align-items: center;">관리대장물질</span>
              <span class="border-right" style="display: grid; align-items: center;">특수건강진단</span>
              <span class="border-right" style="display: grid; align-items: center;">작업환경측정</span>
              <span style="display: grid; align-items: center;">기타<br>(경고표지 부착, 특별교육 등)</span>
            </div>
          </div>
        </div>
        <div class="row-header__item border-right">비고</div>
      </div>

      <!-- rows -->
      <draggable class="w-full" :list="tableList" handle=".handle">
        <div
          class="w-full grid row-content border-left"
          :style="!isPrint?
           'grid-template-columns: 36px 60px 213fr 120px 120px 400fr 54px 40px 40px 40px 40px 180px 213fr'
           : 'grid-template-columns: 60px 213fr 120px 120px 400fr 54px 40px 40px 40px 40px 180px 213fr'"
          v-for="(rows, indexRows) in tableList"
          :key="indexRows"
        >
          <div v-if="!isPrint" class="none-border-center border-right border-bottom h-full">
            <vs-checkbox v-model="rows.is_checked"></vs-checkbox>
          </div>

          <!-- No. -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display:flex; justify-content: center; align-items: center;">
            <span>{{ indexRows + 1 }}</span>
          </div>

          <!-- 물질명(제품명) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.물질명" class="w-full flex-1 p-1" placeholder="예시)ZIC VEGA 46"/>
            <span v-else class="print-input">{{ rows.물질명 }}</span>
          </div>

          <!-- 취급량(L/월) -->
          <div class="item-area p-1 border-right border-bottom h-full" style="align-self: center;">
            <div v-if="!isPrint" class="flex-1 flex items-center">
              <ml-input rows="1" v-model="rows.취급량" class="w-full flex-1 p-1" placeholder="입력"/>
              <span class="px-1">L</span>
            </div>
            <span v-else class="print-input">{{ rows.취급량 }}L</span>
          </div>

          <!-- 사용기간(시간/월) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <div v-if="!isPrint" class="flex-1 flex items-center">
              <ml-input rows="1" v-model="rows.사용빈도" class="w-full flex-1 p-1" placeholder="입력"/>
              <span class="px-1">시간</span>
            </div>
            <span v-else class="print-input">{{ rows.사용빈도 }}시간</span>
          </div>

          <!-- 사용용도(작업내용) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-textarea v-if="!isPrint" rows="2" v-model="rows.사용용도" class="w-full flex-1 p-1 resize-none" placeholder="예초기 사용 시 휘발유 혼합(엔진오일)"/>
            <span v-else class="print-input">{{ rows.사용용도 }}</span>
          </div>

          <!-- MSDS게시 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center;">
            <vs-checkbox v-if="!isPrint" v-model="rows.MSDS게시"></vs-checkbox>
            <span v-else class="print-checkbox"><i><feather-icon v-if="rows.MSDS게시" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
          </div>

          <!-- MSDS교육 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center;">
            <vs-checkbox v-if="!isPrint" v-model="rows.MSDS교육"></vs-checkbox>
            <span v-else class="print-checkbox"><i><feather-icon v-if="rows.MSDS교육" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
          </div>

          <!-- 관리대장물질 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center;">
            <vs-checkbox v-if="!isPrint" v-model="rows.관리대장물질"></vs-checkbox>
            <span v-else class="print-checkbox"><i><feather-icon v-if="rows.관리대장물질" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
          </div>

          <!-- 특수건강진단 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center;">
            <vs-checkbox v-if="!isPrint" v-model="rows.특수건강진단"></vs-checkbox>
            <span v-else class="print-checkbox"><i><feather-icon v-if="rows.특수건강진단" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
          </div>

          <!-- 작업환경측정 -->
          <div class="item-area p-1 border-right border-bottom h-full" style="display: grid; align-items: center; justify-content: center;">
            <vs-checkbox v-if="!isPrint" v-model="rows.작업환경측정"></vs-checkbox>
            <span v-else class="print-checkbox"><i><feather-icon v-if="rows.작업환경측정" svgClasses="w-4 w-5" icon="CheckIcon" /></i></span>
          </div>

          <!-- 기타(경고표지 부착, 특별교육 등) -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.기타" class="w-full flex-1 p-1" placeholder="경고표지, MSDS교육"/>
            <span v-else class="print-input">{{ rows.기타 }}</span>
          </div>

          <!-- 비고 -->
          <div class="item-area p-1 border-right border-bottom h-full">
            <ml-input v-if="!isPrint" rows="1" v-model="rows.비고" class="w-full flex-1 p-1" placeholder="매월사용X"/>
            <span v-else class="print-input">{{ rows.비고 }}</span>
          </div>
        </div>
      </draggable>
    </div>

    <p class="py-4" style="color:#696D71;">*관리 해당 여부는 물질안전보건자료(MSDS) 내 ‘3. 구성성분의 명칭 및 함유량’ 및 ‘15.법적 규제현황’ 참고</p>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
export default {
  name: 'SubstanceManagementModule',
  components: {
    draggable
  },
  props: {
    title: {
      type: String,
      default: () => '화학물질 관리대장'
    },
    colTitle_1: String,
    colTitle_2: String,
    colTitle_3: String,
    colTitle_4: String,
    value: Array,
    isPrint: Boolean,
    isReadonly: Boolean,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler (value) {
        if (value && value.length > 0) {
          this.tableList = value
        }
      },
    },
    tableList(value){
      this.$emit("input", value)
    }
  },
  methods: {
    checkForm (value, indexRows, text) {
      if (value.target.checked) {
        this.$emit('update-list-check', indexRows - 1, text)
      } else {
        this.$emit('update-list-check', indexRows - 1, '')
      }
    },
    // 항목추가
    handleAddRow () {
      this.tableList.push({
        is_checked: this.tableAllCheck,
        물질명: '',
        취급량: '',
        사용기간: '',
        사용용도: '',
        MSDS게시: '',
        MSDS교육: '',
        관리대장물질: '',
        특수건강진단: '',
        작업환경측정: '',
        기타: '',
        비고: '',
      })
      this.updateList()
    },
    // 선택삭제
    handleRemoveRow () {
      for (let i = 0; i < this.tableList.length; i++) {
        if (this.tableList[i].is_checked) {
          this.tableList.remove(this.tableList[i])
          i = -1
        }
      }

      this.tableAllCheck = false
      this.updateList()
    },
    // 일괄 체크
    changeAllCheck () {
      for (const data of this.tableList) {
        data.is_checked = this.tableAllCheck
      }
    },
    // update
    updateList () {
      this.$emit('updateList', this.tableList)
    },
  },
  data () {
    return {
      tableAllCheck: false,
      tableList: [],
    }
  },
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.label-text {
  width: 127px;
  font-weight: 500;
  font-size: 14px;
}
.mt-component-form {
  margin-top: 25px;
}
.vs-checkbox-default {
  margin: 0;
}
.ml-group-checkBox ~ .ml-group-checkBox {
  margin: 0;
}

/* Table */
.row-header {
  background-color: $bg;
  text-align: center;

  &__checkbox-title {
    height: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-bottom: $border;
    width: 100%;
  }
  &__checkboxs {
    display: flex;
    height: 50%;
    width: 100%;
    div {
      flex: 1;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    div:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
}
.row-header__item {
  border: $border;
  border-left: none;
  border-right: none;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.row-header__item.item-col {
  flex-direction: column;
}
.row-header__item:last-child {
  border-right: none;
}

.none-border-center {
  padding-top: 10px;
  padding-bottom: 10px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

/* row data */
.row-content {
  &__title {
    background-color: $bg;
    height: 100%;
  }
  &__body {
  }
}
.row-content__body-item {
  .item-content {
    padding: 15px;
    border-left: $border;

    pre {
      font-family: "Noto Sans KR", "Montserrat", Helvetica, Arial, sans-serif;
      white-space: pre-wrap;
    }
  }
  .item-box {
    border-left: $border;
    border-right: $border;
    display: flex;
    .item-box-check {
      flex: 1;
      justify-content: center !important;
    }
    .item-box-check:nth-child(2) {
      border-left: $border;
      border-right: $border;
    }
  }
  .item-area {
    padding: 5px;
    align-self: center;
  }
}
.row-content__body-item ~ .row-content__body-item {
  border-top: $border;
}
.vs-component.vs-con-textarea.vs-textarea-primary {
  margin: 0;
}
.row-content-none-data {
  height: 120px;
  border-bottom: $border;
  display: flex;
  justify-content: center;
  align-items: center;
}


.print-radio,
.print-checkbox {
  display: flex;
  align-items: center;

  & > i { width:20px; height: 20px; border:2px solid #cdcdcd; position: relative; }
  & .feather-icon { transform: translateY(-4px); }
}

.print-radio {
  & > i { border-radius: 20px; }
}
</style>
